/**
 * Shared status / priority color + option constants.
 * Previously duplicated across TasksListPage (PRIORITY_COLORS, STATUS_COLORS,
 * STATUS_DOT_COLORS, GANTT_STATUS_COLORS) and referenced ad-hoc by other pages.
 *
 * Consume from here to keep pages consistent.
 */

export const STATUS_OPTIONS = ["Open", "In Progress", "Review", "Paused", "Done"];

export const PRIORITY_OPTIONS = ["Urgent", "High", "Medium", "Low"];

/** Hex dots — used for inline dots, gantt bars, subtle accents */
export const STATUS_DOT_COLORS = {
  "Open": "#64748B",
  "In Progress": "#3B82F6",
  "Review": "#F59E0B",
  "Paused": "#6B7280",
  "Done": "#22C55E",
};

/** Tailwind pill classes — bg + text — for chips / badges */
export const STATUS_PILL_CLASSES = {
  "Open": "bg-slate-500/10 text-slate-400",
  "In Progress": "bg-blue-500/10 text-blue-400",
  "Review": "bg-amber-500/10 text-amber-400",
  "Paused": "bg-gray-500/10 text-gray-400",
  "Done": "bg-green-500/10 text-green-400",
};

/** Hex for priority — used for dots, borders, accents */
export const PRIORITY_COLORS = {
  Urgent: "#DC2626",
  High: "#EF4444",
  Medium: "#F59E0B",
  Low: "#64748B",
};

/** Single-key shortcuts for status changes on a selected row */
export const STATUS_KEY_MAP = {
  o: "Open",
  i: "In Progress",
  r: "Review",
  p: "Paused",
  d: "Done",
};

/** Single-key shortcuts for priority changes on a selected row */
export const PRIORITY_KEY_MAP = {
  u: "Urgent",
  h: "High",
  m: "Medium",
  l: "Low",
};

/** Helper: get dot colour safely */
export function statusDot(status) {
  return STATUS_DOT_COLORS[status] || "#64748B";
}

/** Helper: get priority colour safely */
export function priorityColor(priority) {
  if (!priority) return "#64748B";
  return PRIORITY_COLORS[priority] || "#64748B";
}
